import { render, staticRenderFns } from "./Reserve.vue?vue&type=template&id=b0c4b1a0&scoped=true&"
import script from "./Reserve.vue?vue&type=script&lang=js&"
export * from "./Reserve.vue?vue&type=script&lang=js&"
import style0 from "./reserve.css?vue&type=style&index=0&id=b0c4b1a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c4b1a0",
  null
  
)

export default component.exports